import { useStyle } from "./style";
import { Card, CardContent, Typography } from "@mui/material";
import { useDeviceType } from "@hooks/useDeviceType";
import { ReactNode } from "react";

export interface ICardInfo {
    title: string;
    description: ReactNode;
}

export type ICardInfoList = ICardInfo[];

interface IParams {
    title: string;
    imageSrc: string;
    imageAlt: string;
    cardsInfos: ICardInfoList;
}

export const HomeMarketingInformationCards = (props: IParams) => {
    const { isTabletOrDesktop, isMobileOrTablet, isMobile, isTablet } = useDeviceType();
    const { classes } = useStyle({ isMobileOrTablet, isMobile, isTablet });
    const { title, imageSrc, imageAlt, cardsInfos } = props;

    return (
        <div className={classes.container}>
            {isTabletOrDesktop && <img alt={imageAlt} className={classes.illustration} src={imageSrc} />}
            <div className={classes.contentWrapper}>
                <Typography className={classes.sectionTitle} variant="h2">
                    {title}
                </Typography>
                <div className={classes.cardsGrid}>
                    {cardsInfos.map((cardInfo) => (
                        <Card className={classes.card} key={cardInfo.title}>
                            <CardContent className={classes.cardContent}>
                                <Typography className={classes.cardTitle} variant="large">
                                    {cardInfo.title}
                                </Typography>
                                <Typography className={classes.cardDescription} variant="normal">
                                    {cardInfo.description}
                                </Typography>
                            </CardContent>
                        </Card>
                    ))}
                </div>
            </div>
            {isMobile && <img alt={imageAlt} className={classes.illustration} src={imageSrc} />}
        </div>
    );
};
